<template>
  <div>
    <q-dialog v-model="show" @input="onUpdateModel" @hide="onClose">
      <q-card class="q-card-container">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6"><translate>JDE_STATUS</translate></div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-form @submit="updateStatus" class="q-gutter-md">
          <q-card-section class="form">
            <q-select emit-value map-options outlined v-model="jdeStatusModel" :options="combosOptionsTrueFalse"
              label="Status" :rules="[ val => val != '' || this.$gettext('REQUIRED_FIELD')]" data-testid="jdeStatusComboOption"
              lazy-rules
               />
          </q-card-section>
          <q-card-section class="buttons">
            <q-btn v-close-popup color="grey">
              <translate>CANCEL</translate>
            </q-btn>
            <q-btn color="primary" type="submit" data-testid="updateJdeStatusActionButton">
              <translate>UPDATE_BUTTON</translate>
            </q-btn>
          </q-card-section>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import BillingOrderMethodsComunicate from './BillingOrderMethodsComunicate'

@Component({
  name: 'JdeStatusSelectionModal',
  components: {},
  props: {
    params: Object,
    show: {
      type: Boolean,
      default: false
    }
  }
})
class JdeStatusSelectionModal extends Vue {
  combosOptionsTrueFalse = [{ label: this.$gettext('PROVISSION'), value: 20530001 }, { label: this.$gettext('INVOICE_GENERATION'), value: 20530002 }]
  jdeStatusModel = ''

  onClose () {
    this.jdeStatusModel = ''
    this.params = {}
  }

  onUpdateModel (val) {
    this.$emit('update:model-value', val)
  }

  async updateStatus () {
    const ids = this.params.selected.map(row => row.id)
    await repository.resolveLogic('billingOrderErp.updateJdeStatus', { ids, jdeStatusCode: this.jdeStatusModel })
    this.onUpdateModel(false)
    messageBox.success(this.$gettext('STATUS_CHANGED_WITH_SUCCESS'), 'top-right')
    BillingOrderMethodsComunicate.$emit('refresh-grid', this.params)
  }
}
export default JdeStatusSelectionModal
</script>
<style scoped>
.q-card-container {
  width: 400px;
}

.form {
  margin-top: 5%;
}

.buttons {
  padding: 0 0 16px 0;
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}
</style>
